export const loaderActions = {
    changeLoader({commit}, payload){
        commit('changeLoader', payload)
    },
    changeLoaderB({commit}, payload){
        commit('changeLoaderB', payload)
    },
    changeTableLoader({commit}, payload) {
        commit('changeTableLoader', payload)
    },
    changeBranchesLoader({commit}, payload) {
        commit('changeBranchesLoader', payload)
    },
    changeAppBarTitle({commit}, payload) {
        commit('changeAppBarTitle', payload)
    },
    changeSealChangesLoader({commit}, payload) {
        commit('changeSealChangesLoader', payload)
    }
}

export const sidebarActions = {
    changeDrawerState({commit}, payload) {
        commit('changeDrawerState', payload)
    }
}

export const appBarActions = {
    changeTitle({commit}, payload) {
        commit('setTitle', payload.title)
    }
}

export const flagActions = {
    changeFileNotFoundDialog({commit}, payload) {
        commit('setFileNotFoundDialog', payload)
    }
}
